import { Tag } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const TagIcon = createLucideIcon(Tag);
